import { Component, Input, Output, EventEmitter,OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';

import { WysiwygData } from '@core/models/wysiwyg-data.model';

@Component({
    selector: 'core-layout-modal-message-two-action',
    templateUrl: './modal-message-two-action.component.html',
    styleUrls: ['./modal-message-two-action.component.scss']
})
export class LayoutModalMessageTwoActionComponent implements OnInit {
    // public textControl = new FormControl('');
    public buttonEnabled: boolean = false;
    public message: string;
    @Input() title: string;
    @Input() text: string;
    @Input() messagePlaceholder: string = 'Write your message...';
    @Input() buttonOneText: string;
    @Input() buttonTwoText: string;
    @Input() buttonOneType: string = '';
    @Input() buttonTwoType: string = '';

    @Output() buttonOneClick = new EventEmitter<string>();
    @Output() buttonTwoClick = new EventEmitter<string>();
    @Output() buttonCloseClick = new EventEmitter<string>();

    ngOnInit() {
        // this.textControl.valueChanges.subscribe(value => {
        //     this.buttonEnabled = true;
        //     if(value.trim() == '')
        //         this.buttonEnabled = false;
        //     else {
        //         this.message = value;
        //     }
        // });
    }

    onButtonOneClick(e) {
        this.buttonOneClick.emit(this.message);
    }
    onButtonTwoClick(e) {
        this.buttonTwoClick.emit(this.message);
    }
    onButtonCloseClick(e){
        this.buttonCloseClick.emit(this.message);
    }

    onMessageChange(msgData: WysiwygData){
        // Here we update current FormControl to set value to save with the form.
        

        this.buttonEnabled = true;
        if(msgData.text.trim() == '')
            this.buttonEnabled = false;
        else 
            this.message = msgData.html; // need to be updated to send to save message

    }
}
